function _arrayWithoutHoles(r){if(Array.isArray(r)){for(var t=0,a=new Array(r.length);t<r.length;t++)a[t]=r[t];return a}}module.exports=_arrayWithoutHoles;